import Vue from "vue";
import VueRouter from "vue-router";
import mainLayout from "@/components/mainLayout";
import index from "./modules/index";
import formwork from "./modules/formwork";
import product from "./modules/product";
import code from "./modules/code";
import agent from "./modules/agent";
import assembly from "./modules/assembly";
import boxing from "./modules/boxing";
import warehouse from "./modules/warehouse";
import goods from "./modules/goods";
import manage from "./modules/manage";
import system from "./modules/system";
import updaterecord from "./modules/updaterecord";
import operationlog from "./modules/operationlog";
import verbuy from "./modules/verbuy";
import usermanage from "./modules/usermanage";
import instance from "./modules/instance";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'hash', // 使用 hash 模式，URL 会显示为 #/xxx
    routes: [
        {
            path: '/admin',
            meta: { title: '首页' },
            component: mainLayout,
            children: [
                ...index,
                formwork,
                product,
                ...code,
                agent,
                ...assembly,
                boxing,
                warehouse,
                goods,
                manage,
                system,
                ...updaterecord,
                ...instance,
                ...operationlog,
                ...verbuy,
                usermanage,
            ]
        },
        {
            name: '登录',
            path: '/',
            component: () => import("@/pages/login/login.vue")
        }
    ]
})

// 劫持 push 方法，所有导航都使用 replace 模式
const originalPush = router.push;
router.push = function(location, onResolve, onReject) {
    return originalPush.call(this, location, onResolve, onReject).catch(err => {
        if (onResolve || onReject) throw err;
    });
};

// 监听路由变化，实时替换 URL 为固定地址
router.afterEach((to, from) => {
    if (to.path !== '/') {
        // 保持地址栏显示为 #/admin 或一个固定地址
        history.replaceState(null, '', window.location.pathname + window.location.search + '#/admin');
    }
});

router.beforeEach((to, from, next) => {
    window.document.title = "溯源追溯系统";
    next();
})
export default router;